import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  NotificationContentParams,
  QualificationCategoryName,
} from '@wilson/interfaces';
import { LocalizedDateFormatPipe } from '@wilson/localization';

@Pipe({
  name: 'notificationContentParams',
  standalone: false,
})
export class NotificationContentParamsPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);
  private readonly localizedDateFormat = inject(LocalizedDateFormatPipe);

  transform(
    contentParams: NotificationContentParams,
  ): NotificationContentParams {
    contentParams = contentParams.startDate
      ? {
          ...contentParams,
          startDate: this.localizedDateFormat.transform(
            new Date(contentParams.startDate),
          ),
        }
      : contentParams;

    contentParams = contentParams.endDate
      ? {
          ...contentParams,
          endDate: this.localizedDateFormat.transform(
            new Date(contentParams.endDate),
          ),
        }
      : contentParams;

    contentParams = contentParams.qualificationName
      ? {
          ...contentParams,
          qualificationName: this.translateQualificationName(contentParams),
        }
      : contentParams;
    return contentParams;
  }

  translateQualificationName(contentParams: NotificationContentParams): string {
    let qualificationName = contentParams.qualificationName;
    switch (
      contentParams?.qualificationCategory
        ? contentParams.qualificationCategory
        : ''
    ) {
      case QualificationCategoryName.Certificate:
        qualificationName = this.translate.instant(
          `certificate.${contentParams.qualificationName}`,
        );
        break;
      case QualificationCategoryName.DriverLicense:
        qualificationName = this.translate.instant(
          `driverLicense.${contentParams.qualificationName}`,
        );
        break;
      case QualificationCategoryName.FurtherEducation:
        qualificationName = this.translate.instant(
          `furtherEducation.${contentParams.qualificationName}`,
        );
        break;
      case QualificationCategoryName.Language:
        qualificationName = this.translate.instant(
          `language.${contentParams.qualificationName}`,
        );
        break;
      case QualificationCategoryName.MedicalExamination:
        qualificationName = this.translate.instant(
          `medicalExamination.${contentParams.qualificationName}`,
        );
        break;
      case QualificationCategoryName.More:
        qualificationName = this.translate.instant(
          `otherQualification.${contentParams.qualificationName}`,
        );
        break;
      case QualificationCategoryName.Training:
        qualificationName = this.translate.instant(
          `training.${contentParams.qualificationName}`,
        );
        break;
      default:
        break;
    }
    const data =
      qualificationName +
      ` (${this.translate.instant(
        `qualification_category.${contentParams.qualificationCategory}`,
      )})`;
    return data;
  }
}
